import { getLendersByMerchantId, getMerchantById, getMerchantDataById } from '@nemuru-eng/js-api-client';
import { useParams } from 'react-router-dom';

import { ToDoList } from '@/components/modules/MerchantDetail/MerchantToDo/components/ToDoList';
import { useGetMerchantStructureById } from '@/hooks/requests/merchant/useGetMerchantStructureById';
import { useCache } from '@/hooks/requests/useCache';
import { useSetPageLoadingWhenRequesting } from '@/hooks/requests/useSetPageLoadingWhenRequesting';

export const MerchantToDo = () => {
  const { merchantId } = useParams();

  if (!merchantId) return null;

  const { data: merchant, loading: merchantLoading } = useCache(getMerchantById, { merchantId });
  const { merchantStructure, loading: merchantStructureLoading } = useGetMerchantStructureById(merchantId);
  const { data: lenders, loading: lendersLoading } = useCache(
    getLendersByMerchantId,
    { merchantId },
    { fallbackData: [] },
  );
  const { data: merchantData, loading: merchantDataLoading } = useCache(getMerchantDataById, { merchantId });

  useSetPageLoadingWhenRequesting('MERCHANT_TO_DO_LIST', [
    merchantLoading,
    merchantStructureLoading,
    merchantDataLoading,
    lendersLoading,
  ]);

  if (!merchant || !merchantStructure || !lenders) return null;

  return (
    <ToDoList
      merchant={merchant}
      merchantData={merchantData}
      merchantLenders={lenders}
      merchantStructure={merchantStructure}
    />
  );
};
